@if (open() && menuPosition(); as pos) {
  <div
    #panel
    class="fixed z-[200] max-h-80 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-lg"
    role="listbox"
    [style.top.px]="pos.top"
    [style.left.px]="pos.left"
    [style.width.px]="pos.width"
    (keydown)="onKeyDown($event)"
    (mousemove)="onPanelMouseMove()">
    <div class="border-b border-slate-100 p-2">
      <div
        class="flex items-center gap-2 rounded-lg bg-slate-50 px-2.5 py-2 text-sm text-slate-600">
        <app-svg-icon src="assets/icons/search.svg" [size]="16" class="text-slate-400" />
        <input
          #searchInput
          type="search"
          class="min-w-0 flex-1 bg-transparent outline-none placeholder:text-slate-400"
          placeholder="Search variables..."
          [value]="search()"
          (focus)="onSearchFocus()"
          (input)="onSearchInput($event)"
          (keydown)="onKeyDown($event)" />
      </div>
    </div>

    <div #listScroll class="max-h-64 overflow-y-auto py-1">
      <div class="px-3 pb-1 pt-2">
        <div class="flex items-center justify-between gap-2">
          <span class="text-xs font-semibold text-slate-500">Data Library</span>
          <span class="text-xs text-slate-400">{{ filteredLibrary().length }}</span>
        </div>
        @if (filteredLibrary().length === 0) {
          <p class="px-2 py-2 text-xs text-slate-400">No variables found</p>
        }
        @for (item of filteredLibrary(); track item.id) {
          <button
            type="button"
            [attr.data-slash-id]="item.id"
            class="mt-0.5 flex w-full items-center justify-between gap-3 rounded-lg px-2 py-2 text-left hover:bg-sky-50"
            [class.bg-sky-50]="isSelected(item)"
            (mousedown)="onOptionMouseDown($event)"
            (click)="selectItem(item)"
            (mouseenter)="onOptionMouseEnter(item)">
            <span class="min-w-0 truncate text-xs text-slate-600">{{ item.title }}</span>
            <span class="shrink-0 truncate text-xs text-slate-400">{{ item.valueLabel }}</span>
          </button>
        }
      </div>

      <div class="px-3 pb-2 pt-2">
        <div class="flex items-center justify-between gap-2">
          <span class="text-xs font-semibold text-slate-500">System Variables</span>
          <span class="text-xs text-slate-400">{{ filteredSystem().length }}</span>
        </div>
        @if (filteredSystem().length === 0) {
          <p class="px-2 py-2 text-xs text-slate-400">No system variables found</p>
        }
        @for (item of filteredSystem(); track item.id) {
          <button
            type="button"
            [attr.data-slash-id]="item.id"
            class="mt-0.5 flex w-full items-center justify-between gap-3 rounded-lg px-2 py-2 text-left hover:bg-sky-50"
            [class.bg-sky-50]="isSelected(item)"
            (mousedown)="onOptionMouseDown($event)"
            (click)="selectItem(item)"
            (mouseenter)="onOptionMouseEnter(item)">
            <span class="min-w-0 truncate text-xs text-slate-600">{{ item.title }}</span>
            <span class="shrink-0 truncate text-xs text-slate-400">{{ item.valueLabel }}</span>
          </button>
        }
      </div>
    </div>
  </div>
}
